import {
  CAREER_MOTIVATION_ID_CONSIDERING_CAREER,
  CAREER_MOTIVATION_ID_CURRENTLY_JOB_HUNTING,
  CAREER_MOTIVATION_ID_NO_IDEA,
  CAREER_MOTIVATION_ID_NOT_SELECTED,
  CAREER_MOTIVATION_ID_WANT_TO_HEAR,
  CAREER_MOTIVATION_ID_WITHIN_SIX_MONTHS,
  CAREER_MOTIVATION_ID_WITHIN_THREE_MONTHS,
} from '@findy-code/yuffie/models';
import { PlainButton } from '@findy-code/yuffie/ui/button';
import { useMemo } from 'react';

import styles from './career-motivation-button.component.module.scss';

type Props = {
  onClick?: () => void;
  motivationId?: number;
};

const labelAndStyles: Record<
  number,
  { label: string; keyColor?: string; hasIcon?: boolean }
> = {};

labelAndStyles[CAREER_MOTIVATION_ID_NOT_SELECTED] = {
  label: '設定する',
  keyColor: 'low',
};
labelAndStyles[CAREER_MOTIVATION_ID_CURRENTLY_JOB_HUNTING] = {
  label: '転職活動中',
  keyColor: 'high',
  hasIcon: true,
};
labelAndStyles[CAREER_MOTIVATION_ID_WITHIN_THREE_MONTHS] = {
  label: '3ヶ月以内に転職したい',
  keyColor: 'middle',
  hasIcon: true,
};
labelAndStyles[CAREER_MOTIVATION_ID_WITHIN_SIX_MONTHS] = {
  label: '半年以内に転職したい',
  keyColor: 'middle',
  hasIcon: true,
};
labelAndStyles[CAREER_MOTIVATION_ID_WANT_TO_HEAR] = {
  label:
    process.env.NEXT_PUBLIC_FEATURE_ADD_CAREER_MOTIVATION_STATUS === 'true'
      ? 'よい求人があれば検討したい'
      : '話だけでも聞いてみたい',
  keyColor: 'mild',
  hasIcon: true,
};
if (process.env.NEXT_PUBLIC_FEATURE_ADD_CAREER_MOTIVATION_STATUS === 'true') {
  labelAndStyles[CAREER_MOTIVATION_ID_CONSIDERING_CAREER] = {
    label: 'キャリアについて考え始めている',
    keyColor: 'mild',
    hasIcon: true,
  };
}
labelAndStyles[CAREER_MOTIVATION_ID_NO_IDEA] = {
  label: 'すぐの転職は考えていない',
  keyColor: 'low',
};

export const CareerMotivationButton = ({
  onClick,
  motivationId = CAREER_MOTIVATION_ID_NOT_SELECTED,
}: Props) => {
  const { label, keyColor, hasIcon } = useMemo(() => {
    return (
      labelAndStyles[motivationId] ??
      labelAndStyles[CAREER_MOTIVATION_ID_NOT_SELECTED]
    );
  }, [motivationId]);

  const isSmall =
    process.env.NEXT_PUBLIC_FEATURE_ADD_CAREER_MOTIVATION_STATUS === 'true' &&
    (motivationId === CAREER_MOTIVATION_ID_WANT_TO_HEAR ||
      motivationId === CAREER_MOTIVATION_ID_CONSIDERING_CAREER);

  return (
    <PlainButton
      className={[styles.button, isSmall && styles.small]
        .filter(Boolean)
        .join(' ')}
      data-key-color={keyColor}
      endIcon={hasIcon ? FireIcon : undefined}
      type="button"
      onClick={() => {
        onClick?.();
      }}
    >
      {label}
    </PlainButton>
  );
};

const FireIcon = () => {
  // react-iconがレンダリングするsvgをベースにwidthとheightを1em, fillをcurrentColorに変更している
  // 利用先でCSSでサイズと色の管理を行うため。
  return (
    <svg
      aria-hidden="true"
      fill="none"
      height="1em"
      viewBox="0 0 12 12"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="6" cy="7" fill="white" r="3.5" />
      <path
        d="M7.94453 2C7.53828 2.37695 7.17148 2.77324 6.84648 3.17129C6.31406 2.43789 5.65391 1.69395 4.90625 1C2.98711 2.78066 1.625 5.10078 1.625 6.5C1.625 8.98535 3.58379 11 6 11C8.41621 11 10.375 8.98535 10.375 6.5C10.375 5.45957 9.35977 3.31367 7.94453 2ZM7.56426 8.65332C7.14121 8.94941 6.61953 9.125 6.05586 9.125C4.64668 9.125 3.5 8.19258 3.5 6.67871C3.5 5.92461 3.9748 5.26016 4.92168 4.125C5.05703 4.28086 6.85195 6.57305 6.85195 6.57305L7.99707 5.2668C8.07793 5.40059 8.15156 5.53145 8.21719 5.65684C8.75137 6.67617 8.52598 7.98047 7.56426 8.65332Z"
        fill="currentColor"
      />
    </svg>
  );
};
